import React from "react"
import { Box } from "@mui/system"
import { MyPageMenuItem } from "./MyPageMenuItem"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { MEMBER_TYPE, MENU_TYPE } from "src/modules/const"
import { InboxPage } from "./inbox"
import { ConsultPage } from "./consult"
import { EventsPage } from "./event"
import { NewsPage } from "./news"
import { UsersPage } from "./user"
import { ProfilesPage } from "./profile"
import { BooksPage } from "./books"
import { ContactPage } from "./contact"
import { FavoriteVideoPage } from "./favorite_video"
import { Grid } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useLoginContext } from "src/hooks/useLoginContext"

const menuItems_User = [
  {
    title: "inbox",
    icon: "inbox",
    index: MENU_TYPE.INBOX,
  },
  {
    title: "favorite_video",
    icon: "favorite_video",
    index: MENU_TYPE.FAVORITE_VIDEO,
  },
  {
    title: "register_information",
    icon: "register_information",
    index: MENU_TYPE.REGISTER_INFORMATION,
  },
  {
    title: "contact",
    icon: "contact",
    index: MENU_TYPE.CONTACT,
  },
]

const menuItems_Adviser = [
  {
    title: "inbox",
    icon: "inbox",
    index: MENU_TYPE.INBOX,
  },
  {
    title: "favorite_video",
    icon: "favorite_video",
    index: MENU_TYPE.FAVORITE_VIDEO,
  },
  {
    title: "register_information",
    icon: "register_information",
    index: MENU_TYPE.REGISTER_INFORMATION,
  },
  {
    title: "contact",
    icon: "contact",
    index: MENU_TYPE.CONTACT,
  },
]

const menuItems_Company = [
  {
    title: "register_information",
    icon: "register_information",
    index: MENU_TYPE.REGISTER_INFORMATION,
  },
]

const menuItems_Administrator = [
  {
    title: "inbox",
    icon: "inbox",
    index: MENU_TYPE.INBOX,
  },
  {
    title: "reservation_manage",
    icon: "reservation_manage",
    index: MENU_TYPE.CONSULT_MANAGE,
  },
  {
    title: "event_manage",
    icon: "event_manage",
    index: MENU_TYPE.EVENT_MANAGE,
  },
  {
    title: "notification_manage",
    icon: "notification_manage",
    index: MENU_TYPE.NEWS_MANAGE,
  },
  {
    title: "user_manage",
    icon: "user_manage",
    index: MENU_TYPE.USER_MANAGE,
  },
  {
    title: "register_information",
    icon: "register_information",
    index: MENU_TYPE.REGISTER_INFORMATION,
  },
  {
    title: "book_library_manage",
    icon: "book_library_manage",
    index: MENU_TYPE.BOOK_LIBRARY_MANAGE,
  },
]

interface Props {
  mainMenuIndex: number
  subMenuIndex: number
}

export const MenuLayout = ({ mainMenuIndex, subMenuIndex }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.sidemenu" })

  const { userType } = useLoginContext()

  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  let menuItems: any[] = []
  if (userType == MEMBER_TYPE.USER) {
    menuItems = menuItems_User
  } else if (userType == MEMBER_TYPE.ADVISER) {
    menuItems = menuItems_Adviser
  } else if (userType == MEMBER_TYPE.COMPANY) {
    menuItems = menuItems_Company
  } else if (userType == MEMBER_TYPE.ADMINISTRATOR) {
    menuItems = menuItems_Administrator
  }

  const getMainMenu = () => {
    if (mainMenuIndex == MENU_TYPE.INBOX) {
      return <InboxPage subMenuIndex={subMenuIndex} />
    } else if (mainMenuIndex == MENU_TYPE.FAVORITE_VIDEO) {
      return <FavoriteVideoPage />
    } else if (mainMenuIndex == MENU_TYPE.REGISTER_INFORMATION) {
      return <ProfilesPage subMenuIndex={subMenuIndex} />
    } else if (mainMenuIndex == MENU_TYPE.CONTACT) {
      return <ContactPage />
    } else if (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE) {
      return <ConsultPage subMenuIndex={subMenuIndex} />
    } else if (mainMenuIndex == MENU_TYPE.EVENT_MANAGE) {
      return <EventsPage subMenuIndex={subMenuIndex} />
    } else if (mainMenuIndex == MENU_TYPE.NEWS_MANAGE) {
      return <NewsPage subMenuIndex={subMenuIndex} />
    } else if (mainMenuIndex == MENU_TYPE.USER_MANAGE) {
      return <UsersPage subMenuIndex={subMenuIndex} />
    } else if (mainMenuIndex == MENU_TYPE.BOOK_LIBRARY_MANAGE) {
      return <BooksPage subMenuIndex={subMenuIndex} />
    }

    return null
  }

  const navigate = useNavigate()
  const onMainIndexSelected = (menuIndex: number) => {
    if (menuIndex == MENU_TYPE.INBOX) {
      navigate("/mypage/inbox/consult")
    } else if (menuIndex == MENU_TYPE.FAVORITE_VIDEO) {
      navigate("/mypage/favorite")
    } else if (menuIndex == MENU_TYPE.REGISTER_INFORMATION) {
      navigate("/mypage/profile/update")
    } else if (menuIndex == MENU_TYPE.CONTACT) {
      navigate("/mypage/contact")
    } else if (menuIndex == MENU_TYPE.CONSULT_MANAGE) {
      navigate("/mypage/consult/list")
    } else if (menuIndex == MENU_TYPE.EVENT_MANAGE) {
      navigate("/mypage/event/list")
    } else if (menuIndex == MENU_TYPE.NEWS_MANAGE) {
      navigate("/mypage/news/list")
    } else if (menuIndex == MENU_TYPE.USER_MANAGE) {
      navigate("/mypage/users/list/member")
    } else if (menuIndex == MENU_TYPE.BOOK_LIBRARY_MANAGE) {
      navigate("/mypage/books/list")
    }
  }

  return (
    <Box width="100%" display="flex" className="my_page">
      {isTablet ? (
        <Box className="side_menu">
          {menuItems.map((item, index) => (
            <MyPageMenuItem
              key={`myMenu_${index}`}
              title={t(item.title)}
              icon={item.icon}
              subcount={menuItems.length}
              onClick={() => onMainIndexSelected(item.index)}
              active={item.index === mainMenuIndex}
            />
          ))}
        </Box>
      ) : (
        <></>
      )}

      {getMainMenu()}

      {isTablet ? (
        <></>
      ) : (
        <Grid
          container
          sx={{
            mt: "0px",
            height: "60px",
            borderBottom: "1px dotted #D4D3D7",
            p: "0px",
            position: "absolute",
            bottom: "0px",
          }}
        >
          {menuItems.map((item, index) => (
            <MyPageMenuItem
              key={`myMenu_${index}`}
              title={t(item.title)}
              icon={item.icon}
              subcount={menuItems.length}
              onClick={() => onMainIndexSelected(item.index)}
              active={item.index === mainMenuIndex}
            />
          ))}
        </Grid>
      )}
    </Box>
  )
}
